// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__36DQ1","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__2fQwP","gfeWrapper":"CalendarEvent_gfeWrapper__222AJ"};